import { DynamicFormContextProvider } from "../contexts/dynamic-form/DynamicFormContextProvider";
import { Outlet, useParams } from "react-router";
import { createThemeFromConfig } from "./themes";
import { useThemeContext } from "../contexts/theme/useThemeContext";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import { ThemesApi, type ThemeList } from "api";
import { ThemeContextProvider } from "../contexts/theme/ThemeContextProvider";
import merge from "deepmerge";
import { useApi } from "../hooks/useApi";

export const FormLayout = () => {
  const { formId } = useParams();
  if (!formId) throw new Error("formId is required in FormLayout");
  const { mode, setMode, themes: parentThemes } = useThemeContext();
  const [formThemes, setFormThemes] = useState<ThemeList>({});
  const api = useApi(ThemesApi);

  useEffect(() => {
    const fetchThemes = async () => {
      try {
        const response = await api.apiThemesFormsDocumentIdGet({
          documentId: formId,
        });
        setFormThemes(response);
      } catch (error) {
        console.error("Error fetching form themes:", error);
      }
    };
    fetchThemes();
  }, [api, formId]);

  const mergedThemes = merge(
    removeUndefined(parentThemes ?? {}),
    removeUndefined(formThemes ?? {}),
  );

  const themes = createThemeFromConfig(formThemes, parentThemes);
  const theme = { ...themes[mode] };

  return (
    <>
      <ThemeContextProvider mode={mode} setMode={setMode} themes={mergedThemes}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <DynamicFormContextProvider formId={formId}>
            <Box sx={{ width: "100%", height: "100vh", overflow: "hidden" }}>
              <Box
                id="form-scroll-container"
                sx={{
                  maxHeight: "100vh",
                  height: "100%",

                  overflowY: "auto",
                  // scrollSnapType: "y proximity",
                  // scrollPaddingTop: "16px",
                  scrollBehavior: "smooth",
                  // "& .scroll-item": {
                  //   scrollSnapAlign: "start",
                  // },
                }}
              >
                <Outlet />
              </Box>
            </Box>
          </DynamicFormContextProvider>
        </ThemeProvider>
      </ThemeContextProvider>
    </>
  );
};

function removeUndefined<T>(obj: T): T {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(removeUndefined) as T;
  }

  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = removeUndefined(value);
      }
      return acc;
    },
    {} as Record<string, unknown>,
  ) as T;
}
